import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_openModal} from '../../../shared/reducers/modals';
import {Button, Column, DescriptiveText, Icon, LoadingSpinner, Row} from '../../../shared';
import debug from 'debug';
import {isAuthorized, isEntitled} from '../../../shared/reducers/user';
import useSWR from 'swr';
import useQueryObject from '../../../shared/utils/useQueryObject';

const log = debug('circleblack:advisor:group:summary');

const GroupInfoSummary = ({
  groupID,
  criteriaAction,
  openModal,
}) => {
  const {data: group} = useSWR(`/containers/${groupID}`);
  const {data: criteria} = useSWR(`/advisors/groups/${groupID}/criteria`);
  const [context] = useQueryObject('context');

  log('group', group);

  if (!(group && criteria)) {
    return <LoadingSpinner/>;
  }

  return <Column margin={'0 5px 0 5px'} height={'200px'} layout={{grow: 1}} showDividers={true}>
    {/*TODO this placement is definitely NOT good*/}
    {isEntitled([{group: 'reports', feature: 'core', access: 'c'}])
    && <Button width={'auto'}
               importance={'secondary'}
               size={'md'}
               label={'Generate Report'}
               action={() => openModal({type: 'ContextReportModal', context, shareDisabled: group.counts.clients.total !== 1})}/>}
    {!isAuthorized(['ADVISOR']) && <DescriptiveText>All criteria use the {group.level.toLowerCase()} level view.</DescriptiveText>}
    {criteria.map(c => <Row action={(!c.disabled && criteriaAction) && (() => criteriaAction(c))}
                            key={c.containerID}
                            justifySubRow={'space between'}>
      <Row justifySubRow={'left'} width={'fit-content'}>
        <DescriptiveText preset={'standard'}>{c.displayName}</DescriptiveText>
        {!!c.disabled && <Icon svg={'notAllowed'} color={'#9B9B9B'}/>}
      </Row>
      <DescriptiveText preset={'standard'}>{c.displayType}</DescriptiveText>
    </Row>)}
  </Column>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupInfoSummary);

GroupInfoSummary.propTypes = {
  groupID: PropTypes.number.isRequired,
  advisorID: PropTypes.number,
  session: PropTypes.object,
  openModal: PropTypes.func.isRequired,
  criteriaAction: PropTypes.func,
};
